import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { queryKeys, QUERY_CONFIG } from '../../lib/react-query'
import { dnsApi } from '../../services/api'
import { useAuthStore } from '../../store/authStore'
import type { DnsRecordResults } from '../../app/modules/types/dnsRecord'
import type { OptionsType } from '../../app/modules/types/filters'

/**
 * Hook for fetching paginated DNS records list
 * Automatically refetches when URL params change
 */
export function useDnsRecords() {
  const orgId = useAuthStore((state) => state.orgId)
  const [searchParams] = useSearchParams()
  const params = searchParams.toString()

  return useQuery({
    queryKey: queryKeys.dnsRecords.list(orgId, params),
    queryFn: () => dnsApi.getList(params),
    enabled: !!orgId,
  })
}

/**
 * Hook for fetching DNS record filter options
 * Cached for 15 minutes as these change less frequently
 */
export function useDnsRecordFilterOptions() {
  const orgId = useAuthStore((state) => state.orgId)
  return useQuery({
    queryKey: queryKeys.dnsRecords.filterOptions(orgId),
    queryFn: () => dnsApi.getFilterOptions(),
    staleTime: QUERY_CONFIG.LISTS.staleTime,
    enabled: !!orgId,
  })
}
